import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Automation from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automation'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'automation_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'automation_list',
          component: Automation,
          meta: {
            superAdminOnly: true,
            featureFlag: FEATURE_FLAGS.AUTOMATIONS,
            permissions: ['administrator'],
            // ACESSO-01 (L8b): as regras (`automation_rules#*`), travado: o super admin.
            escopos: ['automations:manage'],
          },
        },
      ],
    },
  ],
};
